/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-05T12:12:37+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RenderToLayer from './../../../internals/RenderToLayer';
import MDialogInline from './MDialogInline';

class MDialog extends Component {
  render() {
    return (
      <RenderToLayer
        className={this.props.className}
        render={this.renderLayer}
        open
        useLayerForClickAway={false}
      />
    );
  }

    renderLayer = () => {
      const {
        className, // eslint-disable-line no-unused-vars
        ...other
      } = this.props;
      return (
        <MDialogInline {...other} />
      );
    }
}
MDialog.propTypes = {
  /**
     * class name for the externale rendered layer - use to identify the layer with css
     */
  className: PropTypes.string,
  /**
    * Action buttons to display below the Dialog content (`children`).
    * This property accepts either a React element, or an array of React elements.
    */
  actions: PropTypes.node,
  /**
    * If set to true, the height of the `Dialog` will be auto detected. A max height
    * will be enforced so that the content does not extend beyond the viewport.
    */
  autoDetectWindowHeight: PropTypes.bool,
  /**
    * If set to true, the body content of the `Dialog` will be scrollable.
    */
  autoScrollBodyContent: PropTypes.bool,
  /**
    * The contents of the `Dialog`.
    */
  children: PropTypes.node,
  /**
    * Force the user to use one of the actions in the `Dialog`.
    * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
    */
  modal: PropTypes.bool,
  /**
    * Controls whether the Dialog is opened or not.
    */
  open: PropTypes.bool.isRequired,
  /**
    * Determines whether the `Dialog` should be repositioned when it's contents are updated.
    */
  repositionOnUpdate: PropTypes.bool,
  /**
    * Override the inline-styles of the root element.
    */
  style: PropTypes.object,
  /**
    * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
    */
  title: PropTypes.node,
  /**
    * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
    *
    * @param {bool} buttonClicked Determines whether a button click triggered this request.
    */
  onRequestClose: PropTypes.func,
};
export default MDialog;

